export default "__VITE_ASSET__8388edb7__"